import { Link } from 'gatsby';
import { OutboundLink } from 'gatsby-plugin-gtag';
import { EuiSpacer } from '@elastic/eui';
import TableFeatures from 'components/Indoor_Cameras/IN-8401_WQHD/Product_Features/TableFeatures';
import TableStatus from 'components/Indoor_Cameras/IN-8401_WQHD/Product_Features/TableStatus';
import NavButtons from 'components/Indoor_Cameras/IN-8401_WQHD/NavButtons';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
import * as React from 'react';
export default {
  Link,
  OutboundLink,
  EuiSpacer,
  TableFeatures,
  TableStatus,
  NavButtons,
  BreadCrumbs,
  SEOHelmet,
  React
};